export type DataEntityId = "clients" | "accounts" | "suppliers";

export interface EntityFilterOption {
  value: string;
  label: string;
}

export interface EntityConfig {
  id: DataEntityId;
  label: string;
  labelSingular: string;
  description: string;
  /** Link to the shared spreadsheet with the required columns for this entity. */
  schemaUrl: string;
  statusOptions: EntityFilterOption[];
}

export const ENTITY_CONFIGS: EntityConfig[] = [
  {
    id: "clients",
    label: "Clientes",
    labelSingular: "cliente",
    description: "Personas o empresas que contratan suscripciones.",
    schemaUrl: "#",
    statusOptions: [
      { value: "ACTIVE", label: "Activo" },
      { value: "INACTIVE", label: "Inactivo" },
    ],
  },
  {
    id: "accounts",
    label: "Cuentas",
    labelSingular: "cuenta",
    description: "Cuentas de streaming y sus perfiles/slots.",
    schemaUrl: "#",
    statusOptions: [
      { value: "ACTIVE", label: "Activo" },
      { value: "INACTIVE", label: "Inactivo" },
    ],
  },
  {
    id: "suppliers",
    label: "Proveedores",
    labelSingular: "proveedor",
    description: "Proveedores que abastecen cuentas y servicios.",
    schemaUrl: "#",
    statusOptions: [
      { value: "ACTIVE", label: "Activo" },
      { value: "INACTIVE", label: "Inactivo" },
    ],
  },
];

export const ACCEPTED_IMPORT_EXTENSIONS = [".xlsx", ".xls"];

export function hasAcceptedExtension(fileName: string) {
  const lower = fileName.toLowerCase();
  return ACCEPTED_IMPORT_EXTENSIONS.some((ext) => lower.endsWith(ext));
}

export function formatFileSize(bytes: number) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

/** Lee un archivo y devuelve su contenido en base64 (sin el prefijo data:...;base64,). */
export function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const base64 = result.split(",")[1] ?? result;
      resolve(base64);
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

/** Dispara la descarga de un Blob en el navegador. */
export function downloadBlob(blob: Blob, fileName: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
